import {Component, OnInit} from '@angular/core';
import {MatCard} from "@angular/material/card";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {Chart, ChartModule} from "angular-highcharts";
import { AnalyseService } from '../../../services/analyse-service/analyse.service';

@Component({
  selector: 'app-order-travail',
  standalone: true,
    imports: [
        MatCard,
        MatMenu,
        MatMenuItem,
        ChartModule,
        MatMenuTrigger
    ],
  templateUrl: './order-travail.component.html',
  styleUrl: './order-travail.component.scss'
})
export class OrderTravailComponent  implements OnInit{
  
    duration: string[] = ['Jour', 'Semaine', 'Mois', 'Année'];
    selectedDuration: string = 'jour';
  
    chartTypess: ('area' | 'bar' | 'column' | 'spline')[] = ['area', 'bar', 'column', 'spline'];
    selectedChartTypess: 'area' | 'bar' | 'column' | 'spline' = this.chartTypess[0];
  
    lineChart: Chart;
    pieChart: Chart;

    dateCountMap: { [key: string]: number } = {};
    statusData: { [key: string]: number } = {
      'En cours': 0,
      'Calucle': 0,
      'Valide': 0
    };

    ngOnInit(): void {
        this.loadAnalyseData(this.selectedDuration)
        this.loadStatusData()
    }


    constructor( private analyseService:AnalyseService){}
    loadAnalyseData(duration: string): void {
        console.log(`🔄 Chargement des données pour la durée : ${duration}`);
    
        this.analyseService.getChartData(duration).subscribe(data => {
          console.log('✅ Données reçues du backend:', data);
    
          const dateCountMap: { [key: string]: number } = {};
          const interpretationData: { [key: string]: number } = {};
    
          // Traitement des données pour les deux graphiques
          data.forEach(item => {
            if (item.creationDate && typeof item.count === 'number') {
              const formattedDate = new Date(item.creationDate).toLocaleDateString();
              dateCountMap[formattedDate] = (dateCountMap[formattedDate] || 0) + item.count;
    
              // Si vous avez un champ "interpretation" dans les données, vous pouvez aussi le compter
              const interpretation = item.interpretation;
              interpretationData[interpretation] = (interpretationData[interpretation] || 0) + 1;
            } else {
              console.warn("⚠️ Donnée ignorée (problème de format) :", item);
            }
          });
    
          // Mise à jour du graphique linéaire (nombre de rapports créés)
          const dates = Object.keys(dateCountMap);
          const counts = Object.values(dateCountMap);
    
          if (this.lineChart) {
            this.lineChart.ref?.update({
              chart: {
                type: this.selectedChartTypess
              },
              series: [{
                type: this.selectedChartTypess,
                name: 'Nombre d Analyse',
                data: counts
              }]
            });
          } else {
            this.lineChart = new Chart({
              chart: {
                type: this.selectedChartTypess
              },
              title: {
                text: `Nombre de analyses créés (${this.selectedDuration})`
              },
              credits: {
                enabled: false
              },
              xAxis: {
                categories: dates,
                title: {
                  text: 'Dates'
                }
              },
              yAxis: {
                title: {
                  text: 'Nombre de analyses'
                },
                min: 0,
                tickInterval: 1,
                labels: {
                  formatter: function () {
                    return String(this.value);
                  }
                }
              },
              series: [{
                type: this.selectedChartTypess,
                name: 'Nombre de analyses',
                data: counts,
                color: 'green'
                }]
            });
          }
        
        }, error => {
          console.error('Erreur lors de la récupération des données du backend:', error);
        });
      }
    
      loadStatusData(): void {
        this.analyseService.getSampleStatusCount().subscribe(statusData => {
          console.log('✅ Réponse brute du backend:', statusData);
      
          if (typeof statusData !== 'object' || Array.isArray(statusData)) {
            console.error('❌ Données invalides reçues du backend:', statusData);
            return;
          }
      
          // Initialisation des compteurs
          const statusCount = {
            'En cours': statusData['En cours'] || 0,
            'Calcule': statusData['Calcule'] || 0,
            'Valide': statusData['Valide'] || 0
          };
      
          console.log('🔍 Statut comptabilisé:', statusCount);
      
          // Mise à jour du graphique pie
          if (this.pieChart) {
            this.pieChart.ref?.update({
              series: [{
                type: 'pie',
                data: [
                  {
                    name: 'En cours',
                    y: statusCount['En cours'],
                    color: 'rgba(0, 128, 255, 0.7)'
                  },
                  {
                    name: 'Calcule',
                    y: statusCount['Calcule'],
                    color: 'rgba(255, 165, 0, 0.7)'
                  },
                  {
                    name: 'Valide',
                    y: statusCount['Valide'],
                    color: 'rgba(34, 177, 76, 0.7)'
                  }
                ]
              }]
            });
          } else {
            this.pieChart = new Chart({
              chart: {
                type: 'pie',
                plotShadow: false,
              },
              credits: {
                enabled: false,
              },
              title: {
                text: 'Répartition des Analyses par Statut'
              },
              tooltip: {
                pointFormat: '<b>{point.y} Analyses</b>'
              },
              series: [{
                type: 'pie',
                data: [
                  {
                    name: 'En cours',
                    y: statusCount['En cours'],
                    color: 'rgba(0, 128, 255, 0.7)'
                  },
                  {
                    name: 'Calcule',
                    y: statusCount['Calcule'],
                    color: 'rgba(255, 165, 0, 0.7)'
                  },
                  {
                    name: 'Valide',
                    y: statusCount['Valide'],
                    color: 'rgba(34, 177, 76, 0.7)'
                  }
                ]
              }]
            });
          }
        }, error => {
          console.error('❌ Erreur lors de la récupération des statuts:', error);
        });
      }
      
      
      
      handleChartType(type: 'area' | 'bar' | 'column' | 'spline') {
        this.selectedChartTypess = type;
        this.loadAnalyseData(this.selectedDuration);
    }
    
}


